import { Link } from "@tanstack/react-router";

import { FOOTER_LINKS } from "@/lib/content";
import { EMAIL, PHONE_DISPLAY, PHONE_E164 } from "@/lib/site";
import { Wordmark } from "@/components/site/wordmark";

export function SiteFooter() {
  return (
    <footer className="bg-plum py-16 text-plum-foreground">
      <div className="mx-auto max-w-7xl px-5 lg:px-10">
        <div className="grid gap-10 md:grid-cols-[1.3fr_1fr_1fr]">
          <div>
            <Wordmark tone="light" />
            <p className="mt-5 max-w-xs text-sm text-plum-foreground/70">
              Handmade doll clothes from Midland, Michigan.
            </p>
          </div>
          <nav aria-label="Footer">
            <h2 className="text-xs font-semibold uppercase tracking-[0.18em] text-gold">
              Quick Links
            </h2>
            <ul className="mt-4 space-y-2.5 text-sm text-plum-foreground/75">
              {FOOTER_LINKS.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="transition-colors hover:text-gold">
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          <div>
            <h2 className="text-xs font-semibold uppercase tracking-[0.18em] text-gold">Contact</h2>
            <ul className="mt-4 space-y-2.5 text-sm text-plum-foreground/75">
              <li>
                <a href={`tel:${PHONE_E164}`} className="hover:text-gold">
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a href={`mailto:${EMAIL}`} className="hover:text-gold">
                  {EMAIL}
                </a>
              </li>
              <li>Midland, Michigan</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 stitch-rule text-gold" aria-hidden="true" />
        <p className="mt-6 text-xs text-plum-foreground/60">
          © 2026 Doll Clothes by Ella Wise. Outfits are handmade to fit 18-inch dolls and are not
          affiliated with any doll manufacturer.
        </p>
      </div>
    </footer>
  );
}
